const planPage = {
  roadmapTitle: "Дорожная карта — vBrain.io",
  overallProgress: "Общий прогресс",
  phase: "Фаза",
  phaseRoutes: "Маршруты в фазе",
  statusComplete: "Завершён",
  statusInProgress: "В работе",
  statusPlanned: "Запланирован",
  clickToChangeStatus: "Нажмите для изменения статуса",
  noRoutes: "Нет маршрутов",
  notes: "Заметки",
  notesPlaceholder: "Заметки к фазе — сводка, риски, цели...",
  realtimeConnected: "Подключено",
  realtimeConnecting: "Подключение...",
  realtimeDisconnected: "Отключено",
  phase1Name: "Базовая инфраструктура",
  phase1Desc: "Sidebar, Layout, Layers, Settings, Automations",
  phase2Name: "Редактор документов",
  phase2Desc: "Canvas Editor с системой полей и шаблонами",
  phase3Name: "Карта историй",
  phase3Desc: "Story Map с 3-уровневым перетаскиванием",
  phase4Name: "AI Центр",
  phase4Desc: "Claude API с режимами работы и стримингом",
  phase5Name: "Контентные страницы",
  phase5Desc: "Design System, Functional Map, Architecture, Plan, Entities",
} as const;
export default planPage;
